import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function LosseFlex({ flex, flexers }) {
    return (_jsx(_Fragment, { children: flex === null || flex === void 0 ? void 0 : flex.map((element, index) => {
            if (!(element === null || element === void 0 ? void 0 : element.fieldGroupName)) {
                return null;
            }
            const fieldGroupName = camalize(element.fieldGroupName);
            if (!flexers[fieldGroupName]) {
                return null;
            }
            const Component = flexers[fieldGroupName];
            return _jsx(Component, { index: index, fields: element }, index);
        }) }));
}
const camalize = (str) => str
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0)
        return ''; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
})
    .replace(/-/g, '');
